/* eslint-disable  */

import React from 'react';
import { useState } from 'react';
import { Button, Grid, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { useTitles } from '~/titles';
import { useDepartments } from '~/departments';


const EmployeeForm = props => {

    // console.log(props)
    
     const {
        setModalOpen,
        initialValues,
        onSubmit
     } = props


    const [name, setName] = useState(initialValues?.name)
    const [title, setTitle] = useState(initialValues?.title)
    const [departments, setDepartments] = useState(initialValues?.departments)
    const [hire_date, setHireDate] = useState(initialValues?.hire_date)
    const [kronos_id, setKronosId] = useState(initialValues?.kronos_id)
    const [enabled, setEnabled] = useState(false)


   
    const { data: globalTitles, isLoading: titlesLoading } = useTitles();
    const { data: globalDepartments, isLoading: departmentsLoading } = useDepartments();
    // console.log(globalDepartments, 'here')



    //filter options
    const optionDepartments = () => { 
        const currentDepartmentsIds = departments?.map(el => el.id)
        return globalDepartments?.filter(optDept => !currentDepartmentsIds?.includes(optDept.id))
    }
   
    

    const validateForm = () => {
        if (name && title && departments && kronos_id) {
            setEnabled(true)
        }
    }

    // handles to change the state of the form fields once are clicked.
    const handleSubmit = async (event)  => {
        event.preventDefault();
        setEnabled(true)
        setModalOpen(false)

        const _departments = departments.map(dept => {

            return { id: dept.id };
        });

        const _title = { id: title.id };


        onSubmit && onSubmit({
            ...initialValues,
            name,
            title: _title,
            departments: _departments,
            hire_date,
            kronos_id
        })

    }


    //Handle change for input fields

    const handleChangeName = (e) => {
        setName(e.target.value)
        validateForm()
        }

    const handleChangeTitle = (e, title) => {
        setTitle(title)
        validateForm()
        }

    const handleChangeDepartments = (e, departments) => {
        setDepartments(departments)
        validateForm()
        }

    const handleChangeHireDate = (e, hire_date) => {
        setHireDate(hire_date)
        validateForm()
        }
        // console.log(hire_date, '31111')

    const handleChangeKronosId = (e) => {
        setKronosId(e.target.value)
        validateForm()
        }
    


        return (
           
                <form onSubmit={handleSubmit} style={styles.root}>

                    <TextField name='employee'
                        value={name || ''}
                        label= 'Employee Name'
                        InputProps={{readOnly: false}}
                        onChange={handleChangeName}
                        fullWidth
                        >            
                    </TextField>

                    <Autocomplete name='title_id'
                        loading={titlesLoading}
                        fullWidth
                        options={globalTitles || []}
                        getOptionLabel={opt => opt.name || ''}
                        renderInput={params => <TextField {...params} required label='Titles' />}
                        value={(title || [])}             
                        onChange={handleChangeTitle}
                   >
                    </Autocomplete>
                    
                    <Autocomplete 
                        multiple
                        name='departments'
                        loading={departmentsLoading}
                        fullWidth
                        options={optionDepartments() || []}
                        getOptionLabel={opt => opt.name || ''}
                        renderInput={(params) => (<TextField {...params} required label='Departments' />)} 
                        value={departments || []}
                        onChange={handleChangeDepartments}
                     >
                        
                    </Autocomplete>


                    <KeyboardDatePicker
                        name='hire_date'
                        fullWidth
                        disableToolbar
                        variant='inline'
                        format='MM/dd/yyyy'
                        margin='normal'
                        
                        KeyboardButtonProps={{
                            'aria-label': 'change date'
                        }}
                        
                        value={hire_date}
                        onChange={handleChangeHireDate}
                        />


                <TextField name='kronos_id'
                        value={kronos_id || ''}
                        label='Employee Kronos ID'
                        InputProps={{readOnly: false}}
                        onChange={handleChangeKronosId}
                        fullWidth
                >
                </TextField> 


                    <Grid container justifyContent='flex-end' spacing={3} style={{ marginTop: '10px' }}>
                        <Grid item>
                            <Button
                                onClick={() => {
                                    setModalOpen(false);}}
                                children='Cancel'
                                variant='contained'
                            />
                        </Grid>
                        <Grid item>
                            <Button
                                variant='contained'
                                color='primary'
                                type='submit'
                                disabled={!enabled}
                                onClick={ handleSubmit}
                                children='Submit'
                            />
                        </Grid>
                    </Grid>
                </form>
        )
    
};
const validate = values => {

    const errors = {};

    if (!values.name) {
        errors.name = 'Required';
    }

    return errors;
};

const styles = {
    root: {
        margin: '10px'
    }
};


export default EmployeeForm;
